import React from 'react';
import '../../sass/general/index.scss';

export default function Footer() {
    return (
        <footer className="footer">
            <ul>
                <li>
                    <a href="https://cleantalk.org/">cleantalk.org</a>
                </li>
                <li>
                    <a href="https://cleantalk.org/my">Dashboard</a>
                </li>
                <li>
                    <a href="https://cleantalk.org/help">Help</a>
                </li>
                <li>
                    <a href="https://cleantalk.org/publicoffer">License</a>
                </li>
                <li>
                    <a href="https://cleantalk.org/publicoffer#refund">Refund policy</a>
                </li>
                <li>
                    <a href="https://cleantalk.org/publicoffer#privacy">Privacy policy</a>
                </li>
            </ul>
        </footer>
    );
}
